import React from "react";
import "./ScriptBook.css";
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import TextLabel from "../../Controls/TextLabel.mjs";
import Step from "./Step.mjs";
import CastItem from "./CastItem.mjs";

const G = window.glob;

const ScriptBook = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tab: 'Script',
			copione: G.getStatus('Copione'),
			players: G.getStatus('Players')
		}
		this.uid = G.generateUid('ScriptBook');
		if ( this.state.players ) G.api({ entity:"admin",operation:"cast"}).then( p => {
			try {
				this.state.players = p?.player;
			} catch(e) {
				this.setState({ players: p?.player });
			}
		});
	}
	componentDidMount() {
		G.register('Copione',(c)=>{ this.setState({copione:c})}, this.uid);
		G.register('Players',async ()=>{
			this.setState({players: (await G.api({ entity:"admin",operation:"cast"}))?.player });
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister( this.uid);
	}
	render() {
		if ( ! this.state.copione && this.state.players ) return "";
		return(
			<div
				id={this.uid}
				className={"ScriptBook"}
			>
				<Nav tabs={true}>
					<NavItem key={"Script"}>
						<NavLink
							className={ this.state.tab === 'Script' ? "active" : "inactive"}
							onClick={ ()=>{ this.setState({tab:'Script'}) } }
						>
							<TextLabel value={"Script"} />
						</NavLink>
					</NavItem>
					<NavItem key={"Cast"}>
						<NavLink
							className={ this.state.tab === 'Cast' ? "active" : "inactive"}
							onClick={ ()=>{ this.setState({tab:'Cast'}) } }
						>
							<TextLabel value={"Cast"} />
						</NavLink>
					</NavItem>
				</Nav>
				<TabContent activeTab={this.state.tab}>
					<TabPane tabId={"Script"} className={"animate__animated animate__fadeIn"}>
						<div className={"Steps"}>
							<table>
								<thead>
									<tr>
										<th>
											<TextLabel value={"type"}/>
										</th>
										<th>
											<TextLabel value={"after"}/>
										</th>
										<th>
											<TextLabel value={"max"}/>
										</th>
										<th>
											<TextLabel value={"Role"}/>
										</th>
										<th>
											<TextLabel value={"Name"}/>
										</th>
										<th>
											<TextLabel value={"Description"}/>
										</th>
									</tr>
								</thead>
								<tbody>
								{(this.state.copione.steps ||[]).map( s => <Step key={s.id} step={s} steps={this.state.copione.steps} /> ) }
								</tbody>
							</table>
						</div>
					</TabPane>
					<TabPane tabId={"Cast"} className={"animate__animated animate__fadeIn"}>
						<div className={"Cast"}>
							<table>
								<thead>
								<tr>
									<th>
										<TextLabel value={"Name"} />
									</th>
									<th>
										<TextLabel value={"Authentication"}/>
									</th>
									<th>
										<TextLabel value={"Role(s)"} />
									</th>
								</tr>
								</thead>
								<tbody>
								{
									( this.state.players||[])
										.sort( (a,b)=> a.name.toLowerCase().localeCompare( b.name.toLowerCase() ) )
										.map((p,i) => <CastItem key={i} player={p} /> )
								}
								</tbody>
							</table>
						</div>
					</TabPane>
				</TabContent>
			</div>
		);
	}
}

export default ScriptBook;
